import WPControl from './WPControl';
export default WPControl;
